import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

export const getActiveCallsApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.TICKET.GET_ACTIVE_CALLS,
      method: 'get',
      data: data,
    })
      .then((response) => {
        callback && callback(response.data)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
